import React, { useEffect, useState } from 'react';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import { AddButton, CancelButton, SubmitButton, UpdateButton } from '../../../../components/mui/Buttons/Buttons';
import { useFormik, Form, FormikProvider } from 'formik';
import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import GlobalSelectField from '../../../../components/mui/GlobalSelectField';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';
import { useSnackbar } from 'notistack';
import {
  getCroLeadsAll,
  getCroLeadStatusNew,
  updateFeeDetailshared,
  UpdateStudentStatus,
} from '../../../../redux/features/croSlice';
import { savePaginationData } from '../../../../redux/features/globalDatagridSlice';

const CROStudentStatus = ({ rowData, dispatchdata }) => {
  const [open, setOpen] = useState(false);
  const [confirmBoxApiTriggered,setConfirmBoxApiTriggered] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading, croLeadStatusNew } = useSelector((state) => state.cro);
  const { paginationData } = useSelector((state) => state.globalDataGrid);

  const ValidationSchema = Yup.object().shape({
    cro_lead_status: Yup.string().required('Update Student Status'),
    fee_details_shared: Yup.string().when('cro_lead_status', {
      is: (value) => parseInt(value) === 1, // Check if cro_lead_status is '1' (Enrolled)
      then: Yup.string().required('Please confirm if fee details are shared'),
      otherwise: Yup.string().notRequired(),
    }),
  });

  const getStatusIdFromName = (name) => {
    const match = croLeadStatusNew.find((status) => status.cro_lead_status_name === name);
    return match ? match.cro_lead_status_id : '';
  };

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      cro_assignment_id: rowData?.cro_assignment_id,
      cro_lead_status: getStatusIdFromName(rowData?.student_status),
      cro_remarks: rowData?.croRemarks,
      fee_details_shared: '',
    },
    validationSchema: ValidationSchema,
    onSubmit: (values) => {
      dispatch(UpdateStudentStatus(values)).then((res) => {
        if (res.payload.status === 'success') {
          enqueueSnackbar(res.payload.message, {
            variant: 'success',
          });
          dispatch(getCroLeadsAll(dispatchdata));
          setOpen(false);
          dispatch(savePaginationData({ ...paginationData, openAnchor: false }));
        } else {
          enqueueSnackbar(res.payload.message, {
            variant: 'error',
          });
          // setOpen(false);
        }
      });
    },
  });

  useEffect(() => {
    if (open) {
      dispatch(getCroLeadStatusNew());
    }
  }, [open]);

  const [showConfirmBox, setShowConfirmBox] = useState(false);
  const [isFeeDetailsConfirmed, setIsFeeDetailsConfirmed] = useState(false);

  const handlefeeDetailsChange = (event) => {
    const value = event.target.value;
    formik.setFieldValue('fee_details_shared', value);

    if (value === '1') {
      setShowConfirmBox(true);
    } else {
      setShowConfirmBox(false);
    }
  };

  const handleConfirmYes = () => {
    const payload = {
      course_enrollment_id: rowData?.course_enrollment_id,
    };

    dispatch(updateFeeDetailshared(payload)).then((res) => {
      if (res.payload?.status === 'success') {
        enqueueSnackbar(res.payload.message, { variant: 'success' });
        setIsFeeDetailsConfirmed(true);
        setConfirmBoxApiTriggered(true);
      } else {
        enqueueSnackbar(res.payload.message, { variant: 'error' });
      }
    });

    setShowConfirmBox(false);
    formik.setFieldValue('fee_details_shared', '1');
  };

  const handleCancelConfirm = () => {
    formik.setFieldValue('fee_details_shared', '0');
    setShowConfirmBox(false);
  };

  return (
    <GlobalDialog
      title={'Update Student Status'}
      open={open}
      setOpen={setOpen}
      fullWidth
      closeButton={confirmBoxApiTriggered || loading ?false:true}
      popupButton={
        <UpdateButton size="medium" action={() => setOpen(true)}>
          Update
        </UpdateButton>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={'column'} spacing={2}>
                  {/* <GlobalSelectField
                    options={{
                      formik,
                      name: "cro_lead_status",
                      label: "Lead Status",
                      data: croLeadStatusNew,
                      keys: {
                        id: "cro_lead_status_id",
                        value: "cro_lead_status_name",
                      },
                    }}
                  /> */}
                  <TextField
                    select
                    fullWidth
                    label="Student Status"
                    name="cro_lead_status"
                    value={formik.values.cro_lead_status}
                    onChange={formik.handleChange}
                    disabled={confirmBoxApiTriggered}
                  >
                    {croLeadStatusNew.map((status) => (
                      <MenuItem key={status.cro_lead_status_id} value={status.cro_lead_status_id}>
                        {status.cro_lead_status_name}
                      </MenuItem>
                    ))}
                  </TextField>
                  {formik.values.cro_lead_status === 1 && (
                    <Box
                      sx={{
                        boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.2)',
                        padding: 2,
                        borderRadius: 2,
                        backgroundColor: '#fff',
                        border: '1px solid #82abdaff',
                      }}
                    >
                      <FormControl>
                        <FormLabel sx={{ fontSize: 14, fontWeight: 600 }}>Fee Details Shared?</FormLabel>
                        <RadioGroup
                          row
                          name="fee_details_shared"
                          value={formik.values.fee_details_shared || ''}
                          onChange={handlefeeDetailsChange}
                        >
                          <FormControlLabel
                            value="1"
                            control={<Radio disabled={isFeeDetailsConfirmed} />}
                            label="Yes"
                          />
                          <FormControlLabel value="0" control={<Radio disabled={isFeeDetailsConfirmed} />} label="No" />
                        </RadioGroup>

                        {showConfirmBox && (
                          <Box
                            sx={{
                              mt: 1,
                              p: 2,
                              border: '1px solid #8d147bff',
                              borderRadius: 2,
                              backgroundColor: '#fff',
                            }}
                          >
                            <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                              Once confirmed "Yes", you cannot change it.
                            </Typography>
                            <Stack direction="row" spacing={1}>
                              <Button size="small" variant="outlined" color="secondary" onClick={handleCancelConfirm}>
                                Cancel
                              </Button>
                              <Button size="small" variant="contained" color="secondary" onClick={handleConfirmYes}>
                                Confirm
                              </Button>
                            </Stack>
                          </Box>
                        )}
                      </FormControl>
                    </Box>
                  )}
                  {formik.touched.fee_details_shared && formik.errors.fee_details_shared && (
                    <Typography variant="caption" color="error">
                      {formik.errors.fee_details_shared}
                    </Typography>
                  )}
                  <TextField
                    fullWidth
                    label="Remarks"
                    name="cro_remarks"
                    multiline
                    rows={2}
                    value={formik.values.cro_remarks}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </Stack>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: 2 }}>
                  <Stack direction={'row'} spacing={1}>
                    <CancelButton disabled={confirmBoxApiTriggered || loading} size="small" action={() => setOpen(false)}>
                      Cancel
                    </CancelButton>
                    <SubmitButton disabled={loading} size="small" type="submit">
                      {loading ? 'Please wait...' : confirmBoxApiTriggered?'Save & Exit':'Save'}
                    </SubmitButton>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default CROStudentStatus;
